import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { withRouter } from 'react-router-dom';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import Divider from '@material-ui/core/Divider';
import Tooltip from '@material-ui/core/Tooltip';

import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Launch from '@material-ui/icons/Launch';

import Route from '~/providers/Route';
import useStyles from './styles';
import { Badge } from '@material-ui/core';
import lodash from 'lodash';

function ItemWithItems({
  history,
  open,
  item: {
    text,
    Icon = null,
    items,
    dividerTop,
    dividerBottom,
  },
}) {
  const classes = useStyles();
  const [expand, setExpand] = useState(
    items.findIndex(({ route }) => route === history.location.route) > -1
  );

  function handleClick() {
    setExpand(!expand);
  }

  if (!open && expand)
    Icon = ExpandLess;

  return (
    <div className={clsx(!open &&classes.rootWithItems)}>
      {dividerTop && <Divider classes={{ root: classes.divider }} />}

      <ListItem
        button
        classes={{
          root: classes.root,
        }}
        onClick={handleClick}
      >
        { Icon && <ListItemIcon classes={{ root: classes.text }}>
          <Icon />
        </ListItemIcon> }

        <ListItemText
          primary={text}
          classes={{
            primary: classes.text,
          }}
        />

        {expand ? <ExpandLess className={classes.icon} /> : <ExpandMore className={classes.icon} />}
      </ListItem>
      <Collapse in={expand} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {items.map((item, key) =>
            <ItemWithoutItems
              history={history}
              key={key}
              item={item}
              open={open}
              className={open && classes.rootExpand}
            />
          )}
        </List>
      </Collapse>

      {dividerBottom && <Divider classes={{ root: classes.divider }} />}
    </div>
  );
}

function ItemWithoutItems({
  history,
  open,
  className,
  item: {
    route,
    text,
    Icon = null,
    onClick,
    external,
    dividerTop,
    dividerBottom,
    notifications,
  },
}) {
  const classes = useStyles();
  const isSelected = route === history.location.routeMenu;

  return (
    <>
      {dividerTop && <Divider classes={{ root: classes.divider }} />}

      <Tooltip title={text} placement="right" disableHoverListener={open}>
        <ListItem
          button
          classes={{
            root: clsx(classes.root, className),
            selected: classes.rootSelected,
          }}
          selected={isSelected}
          onClick={() => onClick ? onClick() : history.push(route.spec)}
        >
          { Icon && <ListItemIcon classes={{ root: clsx(classes.text, isSelected && classes.textSelected) }}>
            <Icon />
          </ListItemIcon> }

          <ListItemText primary={lodash.truncate(text, { length: 30 })} classes={{ root: clsx(classes.text, isSelected && classes.textSelected) }} />

          {external && <Launch className={classes.icon} />}
          {notifications && <Badge badgeContent={notifications} color="primary" />}
        </ListItem>
      </Tooltip>

      {dividerBottom && <Divider classes={{ root: classes.divider }} />}
    </>
  );
}

function Item(props) {
  if (props.item.items)
    return <ItemWithItems {...props} />;

  return <ItemWithoutItems {...props} />;
}

Item.defaultProps = {
  external: false,
  dividerTop: false,
  dividerBottom: false,
};

Item.propTypes = {
  open: PropTypes.bool.isRequired,
  item: PropTypes.shape({
    text: PropTypes.string.isRequired,
    Icon: PropTypes.any.isRequired, // Não encontrei o tipo que funciona com o icone
    route: PropTypes.instanceOf(Route),
    onClick: PropTypes.func,
    external: PropTypes.bool,
    dividerTop: PropTypes.bool,
    dividerBottom: PropTypes.bool,
  }).isRequired,
};

export default withRouter(React.memo(Item));
